if (!customElements.get('back-button')) {
  class BackButton extends HTMLElement {
    constructor() {
      super();
    }

    handleClick() {
      history.back();
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }
  }
  customElements.define('back-button', BackButton);
}
